import { jsx as t } from "react/jsx-runtime";
import { aJ as e } from "../../../vendor-Dd6qj6gJ.js";
import "react";
import "../../../theme/spacing.js";
import { omitStyleRenderProps as r } from "../../../utils/omitStyleRenderProps/index.js";
import '../../../assets/index38.css';const s = "_section_8on31_1", i = {
  section: s
};
function f(o) {
  return /* @__PURE__ */ t(e, { ...r(o), className: i.section });
}
export {
  f as Section
};
